/**
 * Shared clock (F3-G): a SINGLE `now` signal that advances every `intervalMs` and
 * that all badges/countdowns subscribe to. Avoids creating a `setInterval`
 * per component. The interval stops when there are no subscribers.
 */
import { createSignal, onCleanup } from "solid-js";

const [nowMs, setNowMs] = createSignal(Date.now());
let timer: ReturnType<typeof setInterval> | null = null;
let subscribers = 0;

const TICK_MS = 1000;

function start(): void {
  if (timer === null) {
    timer = setInterval(() => setNowMs(Date.now()), TICK_MS);
  }
}

function stop(): void {
  if (timer !== null) {
    clearInterval(timer);
    timer = null;
  }
}

/**
 * Reactive accessor of the current instant (epoch ms), which advances every second
 * while the subscribing component lives.
 */
export function useNow(): () => number {
  subscribers += 1;
  start();
  onCleanup(() => {
    subscribers -= 1;
    if (subscribers <= 0) {
      subscribers = 0;
      stop();
    }
  });
  return nowMs;
}
